import Alpine from 'alpinejs';
import { videoItemFactory } from './video_item';

Alpine.data('videoItem', videoItemFactory);
